import { telefoneSuporte } from 'config/constantes';

export const handleAjuda = () => {
  window?.open(
    `https://api.whatsapp.com/send?phone=55${telefoneSuporte.replace(/[^0-9]/g, '')}`,
    '_blank',
    'noopener noreferrer'
  );
};
